import style from "../../../assets/scss/sub/startGuide.module.scss";
import {StartGuideOptions} from "./StartGuideOptions";
import {useTranslation} from "react-i18next";

export function PersonalStartGuide() {
    const {t} = useTranslation("startGuide");

    return (
        <div className={style.processContainerWrapper}>
            {/* 01 회원가입 */}
            <StartGuideOptions img={"personal_info_01"} idx={1} title={t('personal.step1.title')}
                               containerStyle={"balanceBottom"}>
                <ul className={style.stepDescription}>
                    <li className={style.listItem}>
                        {t('personal.step1.desc')}
                    </li>
                </ul>
            </StartGuideOptions>

            {/* 02 프로필 관리 */}
            <StartGuideOptions img={"personal_info_02"} idx={2} title={t('personal.step2.title')}>
                <ul className={style.stepDescription}>
                    <li className={style.listItem}>
                        {t('personal.step2.desc')}
                    </li>
                    <li className={style.listSubItem}>{t('personal.step2.subDesc')}</li>
                </ul>
            </StartGuideOptions>

            <div className={style.blueBg}>
                {/* 03 이용권 구매 */}
                <StartGuideOptions img={"personal_info_03"} idx={3} title={t('personal.step3.title')}>
                    <ul className={style.stepDescription}>
                        <li className={style.listItem}>
                            {t('personal.step3.desc')}
                        </li>
                        <li className={style.listSubItem}>{t('personal.step3.subDesc')}</li>
                    </ul>
                </StartGuideOptions>

                {/* 04 다운로드 */}
                <StartGuideOptions img={"personal_info_04"} idx={4} title={t('personal.step4.title')}>
                    <ul className={style.stepDescription}>
                        <li className={style.listItem}>
                            {t('personal.step4.desc')}
                        </li>
                        <li className={style.listSubItem}>{t('personal.step4.subDesc')}</li>
                    </ul>
                </StartGuideOptions>

                {/* 05 로그인 */}
                <StartGuideOptions img={"personal_info_05"} idx={5} title={t('personal.step5.title')}>
                    <ul className={style.stepDescription}>
                        <li className={style.listItem}>
                            {t('personal.step5.desc')}
                        </li>
                    </ul>
                </StartGuideOptions>
            </div>

            {/* 06 검사진행 */}
            <StartGuideOptions img={"personal_info_06"} idx={6} title={t('personal.step6.title')}>
                <ul className={style.stepDescription}>
                    <li className={style.listItem}>
                        {t('personal.step6.desc')}
                    </li>
                </ul>
            </StartGuideOptions>

            {/* 07 결과보기 */}
            <StartGuideOptions img={"personal_info_07"} idx={7} title={t('personal.step7.title')}>
                <ul className={style.stepDescription}>
                    <li className={style.listItem}>
                        {t('personal.step7.desc')}
                    </li>
                    <li className={style.listSubItem}>{t('personal.step7.subDesc')}</li>
                </ul>
            </StartGuideOptions>
        </div>
    )
}